import { createParamsStore } from "@/v2/utils/createParamsStore";

export const useOperatorsSelectParams = createParamsStore();
